module.exports = __webpack_public_path__ + "img/king.313523dd.png";